import { apiFetch, httpError } from '../services/apiFetch';

const API_URL = import.meta.env.VITE_API_URL;

// Active-only — for the dropdown on the job-detail screen.
export async function fetchJobTypes() {
    const res = await apiFetch(`${API_URL}/api/JobType/GetJobTypes`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch job types');
    return res.json();
}

// Includes inactive rows — for the settings editor.
export async function fetchJobTypesAdmin() {
    const res = await apiFetch(`${API_URL}/api/JobType/AdminList`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch job types');
    return res.json();
}

export async function createJobType(name) {
    const res = await apiFetch(`${API_URL}/api/JobType/Create`, {
        method: 'POST',
        body: JSON.stringify({ name }),
    });
    if (!res.ok) throw await httpError(res, 'Failed to create job type');
    return res.json();
}

export async function updateJobType(id, name) {
    const res = await apiFetch(`${API_URL}/api/JobType/Update/${id}`, {
        method: 'POST',
        body: JSON.stringify({ name }),
    });
    if (!res.ok) throw await httpError(res, 'Failed to update job type');
    return res.json();
}

export async function toggleJobTypeActive(id) {
    const res = await apiFetch(`${API_URL}/api/JobType/ToggleActive/${id}`, { method: 'POST' });
    if (!res.ok) throw await httpError(res, 'Failed to toggle job type');
}

export async function reorderJobTypes(orderedIds) {
    const res = await apiFetch(`${API_URL}/api/JobType/Reorder`, {
        method: 'POST',
        body: JSON.stringify(orderedIds),
    });
    if (!res.ok) throw await httpError(res, 'Failed to reorder job types');
}
